export default "__VITE_ASSET__BTxCHfhx__"